import { colors, palette } from './tokens/colors'
import { fontFamily, typographyVariants } from './tokens/typography'

export const theme = {
  palette,
  colors,
  typography: {
    family: fontFamily,
    variants: typographyVariants,
  },
} as const

export type Theme = typeof theme
